import HttpClient from "../HttpClient/HttpClient";
import predicareAuthManager from "../PredicareAuth/PredicareAuthManager";
import {getDefaultEndPoint} from "../util/apiEndpoints";

class PackageManager {
    getDefault = user => {
        const httpClient = new HttpClient(user.jwt);
        return httpClient.get(getDefaultEndPoint())
            .then(result => {
                //const user = predicareAuthManager.getUserInfoFromSession();
                for (let essPackage of result) {
                    if (essPackage.language.languageId == user.languageId) {
                        return essPackage;
                    } else {
                        return result[0];
                    }
                }
            });
    };

    setPackageToSessionStorage = packageInfo => {
        sessionStorage.setItem("package", packageInfo);
    };

    getPackageFromSessionStorage = () => {
        sessionStorage.getItem("package");
    };
}

const packageManager = new PackageManager();
export default packageManager;



// WEBPACK FOOTER //
// ./retts/Package/PackageManager.js